<template>
  <svg
    class="c-icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    height="27"
    width="27"
    viewBox="0 0 27 27"
  >
    <use xlink:href="/assets/img/sprite.svg#question" />
  </svg>
</template>